import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { rbacManagementActions } from "../../constants/actionTypes";
import {
  setNewRoleError,
  setUserActionData,
  setRolesListData,
  setPermissionsListData,
  setRolePermissionsData,
  rolePermissionsEditSuccess,
  setCloneRolesList,
  setResourcePermissions,
  setResourcePermissionError,
  errorUserActionData,
  setRolesListError,
  setPermissionsListError,
  rolePermissionsEditError,
  setRolePermissionsError,
  setDeleteActionData,
} from "../actions/rbacManagement";
import {
  fetchRolesList,
  fetchPermissionsList,
  fetchRolePermissionsData,
  editRolePermissions,
  createNewRoleApi,
  fetchCloneRoles,
  deleteSelectedRoleMapping,
  deleteRole,
  resourcePermissions,
} from "../api/rbacManagement";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { errorWentWrong, toasterFlags } from "../../constants/componentConstants";

export function* fetchRolesListFunction({ payload }) {
  try {
    const data = yield call(fetchRolesList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setRolesListData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setRolesListError());
    }
  } catch (err) {
    yield put(setRolesListError(err));
  }
}

export function* fetchPermissionsListFunction({ payload }) {
  try {
    const data = yield call(fetchPermissionsList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setPermissionsListData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setPermissionsListError(data));
    }
  } catch (err) {
    console.log(err);
    yield put(setPermissionsListError(err));
  }
}

export function* fetchRolePermissionsDataFunction({ payload }) {
  try {
    const data = yield call(fetchRolePermissionsData, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setRolePermissionsData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setRolePermissionsError(data));
    }
  } catch (err) {
    yield put(setRolePermissionsError(err));
  }
}

export function* editRolePermissionsFunction({ payload }) {
  try {
    const data = yield call(editRolePermissions, payload);
    if (data?.status === statusCode.Created201) {
      toastNotification(toasterFlags.SUCCESS, `${data?.data?.Success}`);
      yield put(rolePermissionsEditSuccess(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(rolePermissionsEditError(data));
    }
  } catch (err) {
    yield put(setRolePermissionsError(err));
  }
}

export function* createNewRoleFunction({ payload }) {
  try {
    const response = yield call(createNewRoleApi, payload);
    if (response?.status === statusCode.Created201) {
      yield put(setUserActionData(response));
    } else {
      yield put(setNewRoleError(response));
      toastNotification(toasterFlags.ERROR, response?.data?.message || errorWentWrong);
    }
  } catch (err) {
    yield put(setNewRoleError(err));
  }
}

export function* fetchCloneRolesFunction() {
  try {
    const data = yield call(fetchCloneRoles);
    if (data?.status === statusCode.Ok200) {
      yield put(setCloneRolesList(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setRolesListError(data));
    }
  } catch (err) {
    yield put(setRolesListError(err));
  }
}

export function* deleteRoleFunction({ payload }) {
  try {
    const roleResponse = yield call(deleteSelectedRoleMapping, payload);
    if (roleResponse.status === statusCode.Ok200) {
      const permissionResponse = yield call(deleteRole, payload);
      if (permissionResponse.status === statusCode.Ok200) {
        yield put(setUserActionData(permissionResponse));
        yield put(setDeleteActionData(permissionResponse));
      } else {
        toastNotification(toasterFlags.WARN, permissionResponse?.data?.message);
        yield put(errorUserActionData(permissionResponse));
        yield put(setDeleteActionData(permissionResponse));
      }
    } else {
      toastNotification(toasterFlags.WARN, roleResponse?.data?.message);
      yield put(errorUserActionData(roleResponse));
      yield put(setDeleteActionData(roleResponse));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err);
    yield put(errorUserActionData(err));
    yield put(setDeleteActionData(err));
  }
}

export function* getResourcePermission({ payload }) {
  try {
    const permissionResponse = yield call(resourcePermissions, payload);
    if (permissionResponse?.status === statusCode.Ok200) {
      yield put(setResourcePermissions(permissionResponse));
    } else {
      toastNotification(toasterFlags.ERROR, `${permissionResponse?.data?.message}`);
      yield put(setResourcePermissionError(permissionResponse));
    }
  } catch (err) {
    yield put(setResourcePermissionError(err));
  }
}

export function* rbacManagementRootSaga() {
  yield takeLatest(rbacManagementActions.ROLESLISTGETDATA, fetchRolesListFunction);
  yield takeLatest(rbacManagementActions.PERMISSIONSLISTGETDATA, fetchPermissionsListFunction);
  yield takeLatest(rbacManagementActions.ROLEPERMISSIONSGETDATA, fetchRolePermissionsDataFunction);
  yield takeLatest(rbacManagementActions.ROLEPERMISSIONSEDITREQUEST, editRolePermissionsFunction);
  yield takeLatest(rbacManagementActions.CREATENEWROLEREQUEST, createNewRoleFunction);
  yield takeLatest(rbacManagementActions.FETCH_CLONE_ROLES, fetchCloneRolesFunction);
  yield takeLatest(rbacManagementActions.DELETE_ROLE, deleteRoleFunction);
  yield takeLatest(rbacManagementActions.GET_RESOURCE_PERMISSIONS, getResourcePermission);
}

export default function* rootSaga() {
  yield all([fork(rbacManagementRootSaga)]);
}
